<template>
  <ElPopover
    popper-class="field-config-popper"
    trigger="click"
    width="auto">
    <div class="form-sub-title mb-1" style="margin-top: 10px;">
      请勾选要显示的字段
      <ElCheckbox class="ml-1" v-model="checkAll"
                  :indeterminate="isIndeterminate"
                  @change="handleCheckAll">全选
      </ElCheckbox>
      <ElButton class="ml-1" size="mini" icon="el-icon-refresh" @click="handleInitChecks">还原默认值</ElButton>
    </div>
    <ElCheckboxGroup class="grid field-config" v-model="modelValue" @change="handleSelectedFields">
      <ElCheckbox v-for="item in studentColumns" class="mt-1" :key="item.prop"
                  :label="item.prop">
        {{ item.label }}
      </ElCheckbox>
    </ElCheckboxGroup>
    <ElButton slot="reference" icon="el-icon-setting" size="small">
      字段配置
    </ElButton>
  </ElPopover>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'PopoverSelectFields',
  props: {
    initCheckList: {
      type: Array,
      default: () => ([])
    },
    checkList: {
      type: Array,
      default: () => ([])
    },
    studentColumns: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      checkAll: false
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.checkList
      },
      set(val) {
        this.$emit('update:checkList', val)
      }
    },
    isIndeterminate: {
      get() {
        const checkedCount = this.checkList.length
        const totalCount = this.studentColumns.length
        return checkedCount > 0 && checkedCount < totalCount
      },
      set(val) {
        console.log(val)
      }
    }
  },
  methods: {
    // 全选 全不选
    handleCheckAll(val) {
      this.modelValue = val ? this.studentColumns.map(column => column.prop) : []
    },
    // 还原默认值
    handleInitChecks() {
      this.modelValue = cloneDeep(this.initCheckList)
    },
    // 选择字段后，根据情况控制 isIndeterminate
    handleSelectedFields(val) {
      this.isIndeterminate = val.length > 0 && val.length < this.studentColumns.length
    }
  }
}
</script>

<style lang="scss">
.field-config {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
</style>
